import NavMegaMenu, { MenuColumn, MenuItem, MenuFooter, MenuFooterLink, MenuFooterButton } from '@/components/layout/NavMegaMenu';

type ServicesNavDropdownProps = {
  active: boolean
}

// Content for the "Services" nav menu: the two ways to consume the data (the
// hosted/on-premise API and bulk downloads), plus the routes to evaluate and
// buy it. Lower-traffic help & trust links drop to the quiet footer strip.
// The interaction mechanics live in NavMegaMenu.
export default function ServicesNavDropdown({ active }: ServicesNavDropdownProps) {
  return (
    <NavMegaMenu
      label="Services"
      href="/api/"
      active={active}
      footer={
        <>
          <MenuFooter label="Resources">
            <MenuFooterLink href="/docs/commercial/exemption/">Non-commercial use</MenuFooterLink>
            <MenuFooterLink href="https://trust.opensanctions.org">Trust Center</MenuFooterLink>
            <MenuFooterLink href="/docs/commercial/faq/">Commercial FAQ</MenuFooterLink>
            <MenuFooterLink href="/support/">Get support</MenuFooterLink>
          </MenuFooter>
          <MenuFooterButton href="/account/">Customer portal</MenuFooterButton>
        </>
      }
    >
      {/* TODO: rework this */}
      <MenuColumn heading="Screening API">
        <MenuItem href="/api/" title="OpenSanctions API" desc="Sanctions and PEP screening" />
        <MenuItem href="/docs/on-premise/" title="On-premise deployment" desc="Make the database come to you" />
      </MenuColumn>
      <MenuColumn heading="Data licensing">
        <MenuItem href="/licensing/screening/" title="Screening license" desc="Run your own screening" />
        <MenuItem href="/licensing/reseller/" title="Reseller/OEM" desc="Embed the data in your product" />
      </MenuColumn>
      <MenuColumn heading="Learn more">
        <MenuItem href="/showcase/" title="Showcase" desc="Who uses OpenSanctions" />
        <MenuItem href="/sales/" title="Talk to sales" desc="Licensing & commercial use" />
      </MenuColumn>
    </NavMegaMenu>
  );
}
